import { render, staticRenderFns } from "./DelivOrders.vue?vue&type=template&id=0333b782&lang=pug"
import script from "./DelivOrders.vue?vue&type=script&lang=js"
export * from "./DelivOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports